function fallbackCopy(text: string): void {
  const area = document.createElement('textarea')
  area.value = text
  area.style.position = 'fixed'
  area.style.opacity = '0'
  document.body.appendChild(area)
  area.select()
  try {
    document.execCommand('copy')
  } catch {
    // 여기까지 실패하면 하객이 직접 길게 눌러 복사하는 수밖에 없다.
  }
  area.remove()
}

/** iOS 사파리는 사용자 제스처 밖에서 Clipboard API를 거절한다. 폴백을 항상 남긴다. */
export async function copyText(text: string): Promise<void> {
  const clipboard = navigator.clipboard
  if (clipboard?.writeText) {
    try {
      await clipboard.writeText(text)
      return
    } catch {
      // 폴백으로 내려간다.
    }
  }
  fallbackCopy(text)
}
